import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { MzicSvgComponent } from '@mzic/mzic-components';

@Component({
  selector: 'lib-result-step',
  imports: [CommonModule, TranslocoModule, MzicSvgComponent],
  providers: [
    provideTranslocoScope({
      scope: 'mzic-collection-flow',
      alias: 'lang',
    }),
  ],
  templateUrl: './result-step.component.html',
  styleUrl: './result-step.component.scss',
})
export class ResultStepComponent {
  @Input() success = false;
  @Input() message = '';
  @Input() totalFiles = 0; // Changed from reportsDownloaded to totalFiles
  @Input() errorDetails?: string;
  @Input() partnerName = 'Nas Nuvens'; // Changed from publisherName to partnerName
  @Input() integrationEnabled = false;
  @Input() integrationEntityName = '';
  @Input() loading = false; // Loading state during /complete API call

  @Output() retry = new EventEmitter<void>();
  @Output() closeRequested = new EventEmitter<void>();

  get shimmerItems(): number[] {
    return [0, 1]; // 2 info cards
  }

  get integrationSuffix(): string {
    return this.integrationEnabled ? '_integration' : '';
  }

  get successTitleKey(): string {
    return `lang.success_title${this.integrationSuffix}`;
  }

  get successDescriptionKey(): string {
    return `lang.success_description${this.integrationSuffix}`;
  }

  get successCard1DescriptionKey(): string {
    return `lang.success_card_1_description${this.integrationSuffix}`;
  }

  onRetry(): void {
    this.retry.emit();
  }

  onClose(): void {
    this.closeRequested.emit();
  }
}
